import {
  VERMI_BACK_1KG,
  VERMI_FRONT_1KG,
  VERMI_FRONT_5KG,
  VERMIWASH_1,
  VERMIWASH_2
} from "./parasHomeData";

const vermicompostGallery = [
  { src: VERMI_FRONT_1KG, alt: "Paras Organics Vermicompost front pack", thumbAlt: "Front pack" },
  { src: VERMI_BACK_1KG, alt: "Paras Organics Vermicompost back pack", thumbAlt: "Back pack" } ,
  { src: VERMI_FRONT_5KG, alt: "Paras Organics Vermicompost 5 kg pack", thumbAlt: "5 kg pack" }
];

const vermiwashGallery = [
  { src: VERMIWASH_1, alt: "Paras Organics Vermiwash front bottle", thumbAlt: "Front bottle" },
  { src: VERMIWASH_2, alt: "Paras Organics Vermiwash alternate bottle view", thumbAlt: "Bottle view" }
 ];

export const productDetails = {
  vermicompost: {
    slug: "vermicompost",
    name: "Premium Organic Vermicompost",
    badge: "FCO Certified",
    rating: 5,
    reviewCount: 128,
    taxLabel: "Price incl. of all taxes",
    minimumOrderText: "Minimum 2 kg is required for checkout.",
    unitLabel: "kg",
    enquiryLabel: "Enquire Now",
    sizeLabel: "Choose Size",
    amazonUrl: "https://www.amazon.in/s?k=Paras+Organics+Vermicompost",
    gallery: vermicompostGallery,
    sizes: [
      { id: "1kg", label: "1kg", unitCount: 1, price: 149, specialPrice: 129 },
      { id: "5kg", label: "5kg", unitCount: 5, price: 599, specialPrice: 549 },
      { id: "10kg", label: "10kg", unitCount: 10, price: 1049, specialPrice: 949 },
      { id: "20kg", label: "20kg", unitCount: 20, price: 1899, specialPrice: 1699 }
    ],
    shortDescription: [
      "Made from well-digested cow dung and active earthworm castings for richer, living soil.",
      "Improves soil texture, moisture retention, and microbial activity without chemical residues.",
      "Suitable for vegetables, flowers, fruit plants, lawns, nursery plants, and terrace gardens.",
      "Odour-light, easy to handle, and consistent enough for both home gardeners and farms."
    ],
    overview: {
      title: "Build Soil That Keeps Working",
      text: "Paras Organics Vermicompost is designed for growers who want visible plant response and long-term soil improvement. Each batch is processed carefully to deliver stable organic matter, balanced nutrients, and beneficial microbial life that supports roots, foliage, flowering, and yield."
    },
    detailSections: [
      {
        type: "split",
        imageSide: "left",
        image: "https://images.unsplash.com/photo-1466692476868-aef1dfb1e735?auto=format&fit=crop&w=1200&q=80",
        imageAlt: "Healthy seedlings growing in rich soil",
        eyebrow: "Why It Works",
        title: "Healthy Soil, Healthier Plants",
        paragraphs: [
          "The organic matter in vermicompost improves aeration and helps roots move deeper and faster through the soil profile.",
          "It also improves water-holding capacity, which means plants stay more resilient between watering cycles and under hot conditions."
        ],
        bullets: [
          "Encourages stronger root establishment",
          "Supports greener foliage and better flowering",
          "Helps reduce nutrient lock-up in tired soils"
        ]
      },
      {
        type: "split",
        imageSide: "right",
        image: "https://images.unsplash.com/photo-1512428813834-c702c7702b78?auto=format&fit=crop&w=1200&q=80",
        imageAlt: "Hands holding rich organic compost",
        eyebrow: "Prepared Carefully",
        title: "Clean, Mature, and Easy to Apply",
        paragraphs: [
          "We focus on a mature, crumbly texture so the material spreads evenly across pots, beds, borders, and field rows.",
          "That makes it easier to apply near roots, mix into potting media, or use as a seasonal top-dress before watering."
        ],
        bullets: [
          "Fine texture for even distribution",
          "Low-odour handling for home use",
          "Works well with other organic inputs"
        ]
      },
      {
        type: "banner",
        backgroundImage: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=1600&q=80",
        eyebrow: "For Every Growing Space",
        title: "Built for gardens, landscapes, and productive farms",
        text: "Use it to strengthen planting beds, revive weak potting mixes, support orchard basins, or keep kitchen gardens continuously productive through the season."
      },
      {
        type: "composition",
        image: VERMI_FRONT_1KG,
        imageAlt: "Paras Organics Vermicompost pack",
        eyebrow: "Composition",
        title: "FCO-aligned nutrient profile",
        rows: [
          ["Organic Carbon", "18 - 20%"],
          ["Nitrogen (N)", "1.0 - 1.5%"],
          ["Phosphorus (P)", "1.0 - 1.3%"],
          ["Potassium (K)", "0.8 - 1.0%"],
          ["Moisture", "20%"],
          ["pH", "6.5 - 7.5"],
          ["Texture", "Fine, crumbly, mature organic matter"]
        ]
      }
    ],
    applications: [
      {
        key: "home",
        image: "/images/home-and-garden-vermicompost.png",
        imageAlt: "Home garden pots and balcony plants",
        title: "Home & Garden",
        description: "Perfect for pots, balcony gardens, kitchen gardens, flowering beds, indoor foliage, and fruit planters.",
        bullets: ["Mix with potting soil before planting", "Top-dress every 45 to 60 days", "Ideal for roses, vegetables, herbs, and ornamentals"]
      },
      {
        key: "landscaping",
        image: "/images/landscaping-vermicompost.png",
        imageAlt: "Landscaped garden beds and green borders",
        title: "Landscaping",
        description: "Supports lawns, avenue plantations, shrub borders, decorative beds, and institutional green spaces.",
        bullets: ["Improves soil structure in repeated planting zones", "Helps maintain color and vigour in ornamental areas", "Useful during bed preparation and seasonal refresh"]
      },
      {
        key: "agriculture",
        image: "/images/agriculture-vermicompost.png",
        imageAlt: "Agricultural field with productive crop rows",
        title: "Agriculture",
        description: "Works well in orchards, vegetable plots, nursery production, and field crops that need improved soil biology.",
        bullets: ["Apply in root zone before irrigation", "Useful during transplanting and basin preparation", "Fits organic and residue-aware growing programs"]
      }
    ],
    howToUse: {
      title: "How to Use Vermicompost",
      intro: "A simple application routine is usually enough to improve soil response noticeably over repeated cycles.",
      steps: [
        {
          image: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=1200&q=80",
          imageAlt: "Gardener loosening soil around a plant",
          title: "Prepare the surface",
          description: "Loosen the top layer of soil around the plant or across the bed so the compost can settle closer to feeder roots."
        },
        {
          image: "https://images.unsplash.com/photo-1592150621744-aca64f48394a?auto=format&fit=crop&w=1200&q=80",
          imageAlt: "Compost being applied around the plant root zone",
          title: "Apply around the root zone",
          description: "Spread evenly around plants. For pots, mix into the top soil layer. For beds and basins, place in a ring around the root area."
        },
        {
          image: "https://images.unsplash.com/photo-1523348837708-15d4a09cfac2?auto=format&fit=crop&w=1200&q=80",
          imageAlt: "Watering garden bed after adding organic fertilizer",
          title: "Water thoroughly",
          description: "Irrigate right after application to help nutrients and microbes move into the active root zone."
        },
        {
          image: "https://images.unsplash.com/photo-1466692476868-aef1dfb1e735?auto=format&fit=crop&w=1200&q=80",
          imageAlt: "Healthy seedlings during repeated growing cycle",
          title: "Repeat through the season",
          description: "Reapply every 45 to 60 days depending on crop intensity, pot size, and soil condition."
        }
      ]
    },
    videos: [
      { id: "sjhBWhUl8Io", title: "Vermicompost basics and organic fertilizer use" },
      { id: "vFlxV2DXEyM", title: "Liquid organic nutrient support for better plant response" }
    ]
  },
  vermiwash: {
    slug: "vermiwash",
    name: "Premium Organic Vermiwash",
    badge: "Liquid Fertilizer",
    rating: 5,
    reviewCount: 74,
    taxLabel: "Price incl. of all taxes",
    minimumOrderText: "Minimum 2 litres is required for checkout.",
    unitLabel: "ltr",
    enquiryLabel: "Enquire Now",
    sizeLabel: "Choose Size",
    amazonUrl: "https://www.amazon.in/s?k=Paras+Organics+Vermiwash",
    gallery: vermiwashGallery,
    sizes: [
      { id: "1ltr", label: "1ltr", unitCount: 1, price: 189, specialPrice: 169 },
      { id: "5ltr", label: "5ltr", unitCount: 5, price: 799, specialPrice: 729 },
      { id: "10ltr", label: "10ltr", unitCount: 10, price: 1449, specialPrice: 1299 },
      { id: "20ltr", label: "20ltr", unitCount: 20, price: 2699, specialPrice: 2399 }
    ],
    shortDescription: [
      "A nutrient-rich liquid extract containing plant-available micronutrients and natural growth stimulants.",
      "Useful as a foliar spray, soil drench, compost booster, or root-zone support input.",
      "Designed for vegetables, ornamentals, orchards, nursery plants, and field crops.",
      "Quick to mix, easy to spray, and effective as part of a regular organic care routine."
    ],
    overview: {
      title: "Fast Support for Active Growth",
      text: "Paras Organics Vermiwash offers a fast, flexible way to support plants during active growth, flowering, and recovery. It is especially useful when growers want an easy liquid application that reaches leaves and roots quickly."
    },
    detailSections: [
      {
        type: "split",
        imageSide: "left",
        image: "/images/vermiwash-Foliar Response.png",
        imageAlt: "Vegetable garden with healthy leaves",
        eyebrow: "Foliar Response",
        title: "Useful when plants need a quick lift",
        paragraphs: [
          "Vermiwash can be diluted and sprayed directly on foliage, making it a practical option for active growth stages.",
          "Growers often use it during flowering, fruit set, or after visible stress when they want a gentler organic input."
        ],
        bullets: [
          "Supports greener, more active foliage",
          "Easy to combine with routine garden care",
          "Suitable for repeated low-dose application"
        ]
      },
      {
        type: "split",
        imageSide: "right",
        image: "/images/vermiwash-vitamin-tonic-for-plants.png",
        imageAlt: "Paras Organics Vermiwash used as a vitamin tonic for healthier plants",
        eyebrow: "Plant Immunity",
        title: "A natural vitamin tonic for stronger plant protection",
        paragraphs: [
          "Paras Organics Vermiwash works like a gentle organic vitamin tonic for plants, helping support stronger natural immunity during active growth, flowering, and recovery phases.",
          "Regular diluted use can improve plant resistance against common insect pressure and disease stress, helping growers gradually reduce dependency on chemical pesticides as part of a balanced organic plant care routine."
        ],
        bullets: [
          "Helps strengthen natural plant immunity",
          "Supports healthier growth against insect and disease stress",
          "Can reduce pesticide dependency over repeated use"
        ]
      },
      /*
      {
        type: "composition",
        image: VERMIWASH_1,
        imageAlt: "Paras Organics Vermiwash bottle",
        eyebrow: "Composition",
        title: "Typical quality markers",
        rows: [
          ["pH", "6.5 - 7.5"],
          ["Organic Carbon", "1.0 - 1.5%"],
          ["Nitrogen (N)", "0.01 - 0.10%"],
          ["Phosphorus (P)", "0.01 - 0.05%"],
          ["Potassium (K)", "0.5 - 1.0%"],
          ["Use Form", "Diluted foliar spray or soil drench"]
        ]
      }
      */
    ],
    applications: [
      {
        key: "home",
        image: "/images/home-and-garden-vermiwash.png",
        imageAlt: "Leafy home garden plants ready for foliar spray",
        title: "Home & Garden",
        description: "Use on terrace vegetables, flowering plants, indoor greens, and kitchen herbs.",
        bullets: ["Best used as a diluted foliar spray", "Apply in cooler morning or evening hours", "Useful for repeat feeding in pots"]
      },
      {
        key: "landscaping",
        image: "/images/landscaping-vermiwash.png",
        imageAlt: "Ornamental landscape planting under maintenance",
        title: "Landscaping",
        description: "Good for decorative planting zones and maintenance of ornamental greens.",
        bullets: ["Useful for maintenance spray programs", "Helps support uniform foliage quality", "Suitable for lawn-edge and shrub maintenance"]
      },
      {
        key: "agriculture",
        image: "/images/aggriculture-vermiwash.png",
        imageAlt: "Agricultural crop rows suited for liquid organic application",
        title: "Agriculture",
        description: "Can be used for vegetables, orchard crops, and nursery stock as a supportive organic liquid input.",
        bullets: ["Use as foliar spray or soil drench", "Helpful during vegetative and flowering phases", "Can complement solid organic manures"]
      }
    ],
    howToUse: {
      title: "How to Use Vermiwash",
      intro: "Dilute before use and apply during cooler parts of the day for better leaf coverage and gentler plant response.",
      steps: [
        {
          image: "https://images.unsplash.com/photo-1585314062340-f1a5a7c9328d?auto=format&fit=crop&w=1200&q=80",
          imageAlt: "Liquid fertilizer being mixed with water",
          title: "Dilute the concentrate",
          description: "Mix according to crop need. A light foliar routine can begin with roughly 100 ml per litre of water."
        },
        {
          image: "https://images.unsplash.com/photo-1589927986089-35812388d1f4?auto=format&fit=crop&w=1200&q=80",
          imageAlt: "Foliar spray being applied to leaves",
          title: "Spray or drench",
          description: "Apply evenly on leaf surfaces or around the root zone depending on the crop stage and purpose."
        },
        {
          image: "https://images.unsplash.com/photo-1464226184884-fa280b87c399?auto=format&fit=crop&w=1200&q=80",
          imageAlt: "Healthy crop rows in soft morning light",
          title: "Avoid harsh sunlight",
          description: "Spray in early morning or evening to reduce evaporation and improve leaf contact time."
        },
        {
          image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=1200&q=80",
          imageAlt: "Field crop under regular organic care schedule",
          title: "Repeat regularly",
          description: "Continue every 10 to 15 days as part of a balanced organic maintenance schedule."
        }
      ]
    },
    videos: [
      { id: "vFlxV2DXEyM", title: "Understanding vermiwash for spray and growth support" },
      { id: "sjhBWhUl8Io", title: "Organic plant care and soil-support fundamentals" }
    ]
  }
};
